import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

export interface SidebarNavItem {
  to: string;
  label: string;
  end?: boolean;
}

export interface SidebarProps {
  items: SidebarNavItem[];
  footer?: ReactNode;
  /** Mobilde drawer açık mı. Desktop'ta yok sayılır. */
  open?: boolean;
  /** Drawer'ı kapatmak için nav öğesine tıklandığında çağrılır. */
  onNavigate?: () => void;
}

export function Sidebar({
  items,
  footer,
  open = false,
  onNavigate,
}: SidebarProps) {
  return (
    <aside className="qr-sidebar" data-open={open ? "true" : "false"}>
      <nav className="qr-sidebar-nav" aria-label="Ana gezinme">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            className={({ isActive }) =>
              isActive ? "qr-sidebar-link is-active" : "qr-sidebar-link"
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      {footer ? <div className="qr-sidebar-footer">{footer}</div> : null}
    </aside>
  );
}
